export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];
export const NotificationType = {
  Message: 1,
  Notification: 2,
} as const;
